export const setSettings = (state, action) => {
  const payload = action.payload
  state = payload
  return state
}
